import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'jhi-field',
  template: '<ng-content></ng-content>',
  styleUrls: ['./field.component.scss']
})
export class FieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/field/field.component.ts